import React from 'react';

const ReportingContext = React.createContext({
  service: null,
  report: (error, info) => error || info
});

export default ReportingContext;
